// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1b3Ey","title":"FrontImage_title__3812h"};